import React from "react";

export default function SubscriptionHistoryPagination({
  currentPage,
  totalPages,
  totalItems,
  limit,
  onPageChange,
}) {
  if (totalPages <= 1) return null;

  const from = (currentPage - 1) * limit + 1;
  const to = Math.min(currentPage * limit, totalItems);

  return (
    <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 px-3 sm:px-4 py-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="text-xs sm:text-sm font-medium text-gray-700 order-2 sm:order-1 text-center sm:text-left">
        Page <span className="font-bold text-gray-900">{currentPage}</span> of{" "}
        <span className="font-bold text-gray-900">{totalPages}</span> · Total{" "}
        <span className="font-bold text-red-600">{totalItems}</span> records
      </div>
      <div className="flex gap-2 items-center order-1 sm:order-2">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className={`px-3 sm:px-4 py-2 border rounded-lg font-medium text-xs sm:text-sm transition-colors ${
            currentPage === 1
              ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-50 border-gray-300"
          }`}>
          Previous
        </button>
        <span className="text-xs sm:text-sm text-gray-700 min-w-[100px] sm:min-w-[120px] text-center">
          <span className="font-bold">{from}</span>–<span className="font-bold">{to}</span> of{" "}
          <span className="font-bold text-red-600">{totalItems}</span>
        </span>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className={`px-3 sm:px-4 py-2 border rounded-lg font-medium text-xs sm:text-sm transition-colors ${
            currentPage === totalPages
              ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-50 border-gray-300"
          }`}>
          Next
        </button>
      </div>
    </div>
  );
}
